// @flow

import type { AttributeType, ItemType, CategoryType } from '../api/types';

export const camelCaseToNormalString = (string: string): string => {
  string = string.replace(/([a-z\xE0-\xFF])([A-Z\xC0\xDF])/g, '$1 $2');
  string = string.toLowerCase(); //add space between camelCase text

  return string;
};

export const dashedToNormalString = (string: string): string => string.replace(/-/g, ' ');

export const getCategory = (categories: ?Array<CategoryType>, name: string): CategoryType | void => {
  let category;

  if (categories) {
    category = categories.find(category => category.name.toLowerCase() === name.toLowerCase());
  }

  return category;
};

export const getAttributes = (category: ?CategoryType): Array<AttributeType> => {
  if (category && category.attributes && category.attributes.length) {
    return category.attributes;
  }

  return [];
};

export const getItems = (category: ?CategoryType): Array<ItemType> => {
  if (category && category.items && category.items.length) {
    return category.items;
  }

  return [];
};

export const getOffset = (element: HTMLElement): Object => {
  const offset = ({ top, left }, { offsetTop = 0, offsetLeft = 0, offsetParent }) => {
    const output = { top: top + offsetTop, left: left + offsetLeft };

    // $FlowFixMe
    return offsetParent ? offset({ ...output }, offsetParent) : output;
  };

  return offset({ top: 0, left: 0 }, element);
};

export const getCoords = (elem: HTMLElement): Object => {
  let box = elem.getBoundingClientRect();

  let body = document.body;
  let docEl = document.documentElement;

  // $FlowFixMe
  let scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;

  // $FlowFixMe
  let scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;
  // $FlowFixMe
  let clientTop = docEl.clientTop || body.clientTop || 0;
  // $FlowFixMe
  let clientLeft = docEl.clientLeft || body.clientLeft || 0;

  let top = box.top + scrollTop - clientTop;
  let left = box.left + scrollLeft - clientLeft;

  return {
    top: top,
    left: left,
  };
};



// WEBPACK FOOTER //
// ./src/utils/methods.js